export default __webpack_public_path__ + "static/media/mòrag.3c22c8a5.mp3";